import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';


export default {
  data() {
    return ({
      user_details: {
        "user_role": '',
        "user_id": '',
      },
      group_report_name: '',
      group_feed_description: '',
      group_file_name: '',
      group_file_error: '',
      group_image_preview: null,
      group_audio_file_name: '',
      group_audio_error: '',
      group_audio_file: null,
      group_can_comment: true,
      isGroupRecording: false,
      upload_media: null,
      audio_file: null,
      errors: {},
      group_id: null,
    });
  },

  mounted() {
    this.user_details = get_user_details();
  },
  methods: {
    handleGroupFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type.startsWith("audio/")) {
          this.group_file_error = "Audio files are not allowed here.";
          this.upload_media = null;
          this.group_file_name = "";
          this.group_image_preview = null;
          event.target.value = "";
        } else {
          this.group_file_name = file.name;
          this.group_file_error = "";
          this.upload_media = file;
          if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.group_image_preview = e.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            this.group_image_preview = null;
          }
        }
      } else {
        this.group_file_name = "";
        this.group_file_error = "";
        this.upload_media = null;
        this.group_image_preview = null;
      }
    },
    handleGroupAudioUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.type.startsWith("audio/")) {
          this.group_audio_error = "Only audio files are allowed.";
          this.group_audio_file = null;
          this.group_audio_file_name = "";
          event.target.value = "";
        } else {
          this.group_audio_file = file;
          this.group_audio_file_name = file.name;
          this.group_audio_error = "";
        }
      } else {
        this.group_audio_file = null;
        this.group_audio_file_name = "";
        this.group_audio_error = "";
      }
    },
    startGroupRecording() {
      // Implement audio recording logic if needed
      this.isGroupRecording = true;
    },
    stopGroupRecording() {
      // Implement stop recording logic if needed
      this.isGroupRecording = false;
    },
    create_group_feed() {
      this.errors = {};
      if (!this.group_report_name) {
        this.errors.group_report_name = 'Feed name is required';
        return;
      }
      this.group_id= this.$route.params.group_id || null;
      const formData = new FormData();
      formData.append('feed_name', this.group_report_name);
      this.group_feed_description=this.$refs.quillGroupFeedEditorRef.getHTML()
      formData.append('description', this.group_feed_description);
      formData.append('group_id', this.group_id);
      formData.append('can_comment', this.group_can_comment);
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }
      if (this.group_audio_file) {
        formData.append('audio', this.group_audio_file, this.group_audio_file_name);
      }
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_group_feed/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${get_token()}`,
        },
        beforeSend: function () {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
        },
        success: (response) => {
          Swal.close();
          const status = response.status;
          if (status === "success") {
            this.$emit('new_group_feed', response.feed_data);
            Swal.fire({
              icon: 'success',
              title: 'Feed Created',
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              $('#group_feed_modal').modal('hide');
              this.resetGroupFeedForm();
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data && response_data.status === "error") {
            this.errors.group_report_name = response_data.message;
          }
        }
      });
    },
    resetGroupFeedForm() {
      this.group_report_name = '';
      this.group_feed_description = '';
      this.group_file_name = '';
      this.group_file_error = '';
      this.group_image_preview = null;
      this.group_audio_file_name = '';
      this.group_audio_error = '';
      this.group_audio_file = null;
      this.upload_media = null;
      this.group_can_comment = true;
      this.isGroupRecording = false;
      this.errors = {};
      this.$nextTick(() => {
        const fileInput = document.getElementById("groupFileInput");
        if (fileInput) fileInput.value = "";
        const audioInput = document.getElementById("groupAudioInput");
        if (audioInput) audioInput.value = "";
      });
    }
  },
};



